<template>
    <div class="google-autocomplete" ref="containerEl" :id="_autoId">

    </div>
</template>

<script>
export default {
    name: 'GoogleAutocomplete',
    emits: ['place-changed'],
    props: {
        name: {
            type: String,
            default: 'google-autocomplete'
        }
    },
    data() {
        return {
            _autoId: `ga-${Math.random().toString(36).slice(2, 9)}`,
            googleMapsAvailable: false,
            cityCordinates: { latitude: 0, longitude: 0 },
            city: '',
            state: 'Unknown'
        }
    },
    watch: {
        modelValue(val) {
            if (val !== this.internalValue) this.internalValue = val
        }
    },
    methods: {
        checkGoogleMapsAvailability() {
            // Check if Google Maps is available
            return new Promise((resolve) => {
                if (typeof google !== 'undefined' && google.maps && google.maps.places) {
                    console.warn('Google Maps JavaScript API is available.');
                    resolve(true);
                } else {
                    console.warn('Google Maps JavaScript API is not available. trying to fetch it again...');

                    // Try to detect if we're offline or Google Maps failed to load
                    const script = document.createElement('script');
                    script.src = 'https://maps.googleapis.com/maps/api/js?key=AIzaSyA-UqcVbHcwFt4842zq8hNhQfX3vUD-hwE&loading=async&libraries=places&v=weekly';
                    script.onload = () => resolve(true);
                    script.onerror = () => resolve(false);

                    // Set a timeout to avoid hanging
                    setTimeout(() => resolve(false), 3000);
                }
            });
        },

        async activateCityInputAutoComplete() {
            try {
                this.googleMapsAvailable = await this.checkGoogleMapsAvailability();
                if (this.googleMapsAvailable) {
                    const maps = google.maps;
                    const autoCompleteOptions = {
                        name: 'city',
                        includedRegionCodes: ['ng'],
                        requestedRegion: 'ng',
                        includedPrimaryTypes: ['locality', 'sublocality', 'neighborhood', 'colloquial_area', 'premise'],
                    };
                    var cityAutocomplete = new maps.places.PlaceAutocompleteElement(autoCompleteOptions);
                    cityAutocomplete.setAttribute('style', 'color-scheme: light;');
                    cityAutocomplete.addEventListener('gmp-select', this.cityPlaceChangedEvent.bind(this), { capture: true });
                    this.$refs.containerEl.appendChild(cityAutocomplete);
                } else {
                    // Fallback to a regular input when Google Maps is not available
                    const fallbackInput = document.createElement('input');
                    fallbackInput.type = 'search';
                    fallbackInput.name = this.name;
                    fallbackInput.className = 'form-control';
                    fallbackInput.placeholder = 'Enter city name';
                    fallbackInput.addEventListener('keydown', (e) => {
                        if (e.key === 'Enter') {
                            this.$emit('place-changed', {
                                city: e.target.value,
                                latitude: 0,
                                longitude: 0
                            });
                        }
                    });
                    this.$refs.containerEl.appendChild(fallbackInput);
                    console.warn('Google Maps JavaScript API not available.');
                }
            } catch (error) {
                console.warn('Google Maps autocomplete not available:', error);
                this.googleMapsAvailable = false;
            }
        },

        async cityPlaceChangedEvent(event) {
            if (!this.googleMapsAvailable) return;
            try {
                const place = event.placePrediction.toPlace();
                await place.fetchFields({ fields: ['displayName', 'location', 'addressComponents'] });
                this.city = place.displayName;
                const addressComponents = place.addressComponents;
                const stateComponent = addressComponents.find(component => component.types.includes('administrative_area_level_1'));
                if (stateComponent) {
                    this.state = stateComponent.longText;
                }
                const geocoder = new google.maps.Geocoder();
                geocoder
                    .geocode({ placeId: place.id })
                    .then(({ results }) => {
                        this.cityCordinates.latitude = results[0].geometry.location.lat();
                        this.cityCordinates.longitude = results[0].geometry.location.lng();
                        this.$emit('place-changed', {
                            city: this.city,
                            latitude: this.cityCordinates.latitude,
                            longitude: this.cityCordinates.longitude,
                            state: this.state
                        });
                    })
                    .catch((e) => {
                        console.warn("Geocoder failed:", e);
                        this.$emit('place-changed', {
                            city: encodeURI(this.city.replace("/", "-").toLowerCase()),
                            latitude: this.cityCordinates.latitude,
                            longitude: this.cityCordinates.longitude,
                            state: this.state
                        });
                    });
            } catch (error) {
                console.warn('Place selection failed:', error);
            }
        },
    },
    mounted() {
        this.activateCityInputAutoComplete();
    }
}
</script>

<style scoped>
.google-autocomplete {
    display: inline-block;
    width: 100%;
}
</style>
